import type { SaveStatus } from '../../hooks/useAutoSave';

const LABELS: Record<SaveStatus, string> = {
  idle: '',
  unsaved: 'Unsaved changes',
  saving: 'Saving…',
  saved: 'Saved',
  error: 'Saved locally',
};

const COLOURS: Record<SaveStatus, string> = {
  idle: 'text-transparent',
  unsaved: 'text-amber-500',
  saving: 'text-blue-500',
  saved: 'text-green-600',
  error: 'text-orange-500',
};

export function SaveStatusIndicator({ status }: { status: SaveStatus }) {
  return (
    <span
      role="status"
      aria-live="polite"
      className={`text-sm font-medium transition-colors duration-200 ${COLOURS[status]}`}
    >
      {LABELS[status]}
    </span>
  );
}
